<template>
    <div></div>
</template>

<script>
    export default {
        created() {
            window.location.href = process.env.VUE_APP_ROOT_URL
        }
    }
</script>
